export {default} from '../../core/components/Home';